<template>
    <div>
        <div v-if="!show && type !== 'html'">
            <div :class="textClass">{{ truncate(text) }}</div>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ clamp }}</button>
        </div>
        <div v-else-if="!show && type === 'html'">
            <div :class="textClass">
                <span v-html="truncate(text)"></span>
                <button
                    type="button"
                    v-if="isExpandable && text.length >= length"
                    :class="actionClass"
                    @click="toggle()"
                >{{ clamp }}</button>
            </div>
        </div>
        <div v-if="show && type !== 'html'">
            <div>{{ text }} </div>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ less }}</button>
        </div>
        <div v-else-if="show && type === 'html'">
            <div v-if="text.length >= length" v-html="text"></div>
            <button
                type="button"
                v-if="isExpandable && text.length >= length"
                :class="actionClass"
                @click="toggle()"
            >{{ less }}</button>
            <div v-else>{{ truncate(text) }}</div>
        </div>
    </div>
</template>
<script>
import htmlTruncate from 'html-truncate'

/**
 * Truncates a block of text to a specified character count and adds a "Read More"
 * button that expands the text to it's full character count.
 * This requires the {@link https://github.com/huang47/nodejs-html-truncate} module
 * @module TruncateComponent
 * @requires htmlTruncate
 * @param {String} [collapsedTextClass=''] - The class of the collapsed text
 * @param {String} text - The text to truncate
 * @param {String} [clamp='Read More'] - The button text for expanding the truncated text
 * @param {Number} [length=100] - The length of the text
 * @param {String} [less='Show Less'] - The button text for collapsing the text after it's been expanded
 * @param {String} [type='text'] - The type of text ('html', 'text')
 * @param {String} [actionClass=''] - The class of the clamp and less button
 * @param {Boolean} [isExpandable=true] - False if you don't want the text to be expandable
 * @param {Boolean} [useModal=false] - Whether a modal should be used
 * @param {Boolean} [preventChopping=false] - Whether to prevent chopping of a sentence
 * @prop {Boolean} show - Whether all the text is showing
 * @prop {String} textClass - The class of the text
 * @example
 * <truncate
 *     clamp="Read More"
 *     :length="128"
 *     action-class="community-welcome__article-button"
 *     less="Show Less"
 *     type="html"
 *     text="{!! $community->welcome_copy !!}"
 * ></truncate>
 */
export default {
    name: 'Truncate',
    props: {
        collapsedTextClass: {type: String, default: ''},
        text: {type: String, required: true},
        clamp: {type: String, default: 'Read More'},
        length: {type: Number, default: 100},
        less: {type: String, default: 'Show Less'},
        type: {type: String, default: 'text'},
        actionClass: {type: String, default: ''},
        isExpandable: {type: Boolean, default: true},
        useModal: {type: Boolean, default: false},
        preventChopping: {type: Boolean, default: false}
    },
    data: () => ({
        show: false
    }),
    computed: {
        textClass() {
            return (this.text.length > this.length && this.collapsedTextClass) ? this.collapsedTextClass : '';
        }
    },
    mounted() {
        // console.group('Text');
        // console.log(this.text);
        // console.groupEnd();
        // console.group('Truncate');
        // console.log(this.truncate(this.text));
        // console.groupEnd();
        // console.group('Truncate Without Chopping');
        // console.log(this.truncateWithoutChopping(this.text));
        // console.groupEnd();
        // console.group('Truncate HTML');
        // console.log(this.htmlTruncate(this.text));
        // console.groupEnd();
    },
    methods: {

        /**
         * Truncates the text without chopping a sentence
         * @param {String} string - The string to truncate
         * @returns {String} The truncated string
         * @private
         */
        truncateWithoutChopping(string) {
            const fauxdiv = document.createElement('div');
            let modifiedString = string.replace(/(<br(\/)?>)/g, '$br$');
            fauxdiv.innerHTML = modifiedString;
            let content = fauxdiv.textContent || fauxdiv.innerText || '';
            content = content.replace(/\$br\$/g, '<br><br>');
            const sentences = content.match(/[^\.!\?]+[\.!\?]+/g);
            let truncation = '';
            let i = 0;
            let k = 0;
            while (i < this.length) {
                if (sentences[k]) {
                    truncation += sentences[k];
                    k++;
                } else {
                    break;
                }
                 i += sentences[k] ? sentences[k].length : 1;
            }
            return truncation;
        },

        /**
         * Truncates the text
         * @param {String} string - The string to truncate
         * @returns {String} The truncated string
         * @private
         */
        truncate(string) {
            let result = '';
            if (string) {
                if (this.preventChopping) {
                    result = this.truncateWithoutChopping(string);
                } else {
                    result = this.type === 'html'
                        ? htmlTruncate(string, this.length)
                        : string.toString().substring(0, this.length);
                }
            }
            return result;
        },

        /**
         * Truncates the html
         * @param {String} text - The html content to truncate
         * @returns {String} The truncated html content
         * @private
         */
        htmlTruncate(text) {
            return htmlTruncate(text);
        },

        /**
         * Toggles the showing/hiding of the entire text content
         * @private
         */
        toggle() {
            if (this.useModal) {
                this.$parent.openModal('modal-info', {content: this.text});
            } else {
                const toggled = !this.show;
                this.show = toggled;
                this.$emit('toggle', toggled);
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/truncate.vue